import React from 'react';
import {withStyles} from 'material-ui/styles';
import {Grid, Typography} from 'material-ui';

const styles = theme => ({
    normalData: {
        fontWeight: 700,
        fontSize: '16px'
    },
    modifiedData: {
        fontWeight: 300,
        fontSize: '14px'
    },
    modifiedDataColor: {
        fontWeight: 300,
        fontSize: '14px', 
        color: theme.palette.primary.main
    }

});

class DetailColumn extends React.Component{

    constructor(props){
        super(props);
    }

    render(){

        const {classes} = this.props;
        const style = this.props.diff ? classes.modifiedDataColor : classes.modifiedData;

        return(
            <Grid item xs={2}>
                <Typography className={classes.normalData}>
                    {this.props[0]}
                </Typography>
                <Typography className={{style}}>
                    {this.props[1]}
                </Typography>
                <Typography className={{style}}>
                    {this.props[2]}
                </Typography>
            </Grid>
        );
    }
}

export default withStyles(styles, { withTheme: true })(DetailColumn);



// WEBPACK FOOTER //
// ./src/components/Reservation/DetailColumn.js